module.exports = __webpack_public_path__ + "static/img/failure_count.3653c212.png";